import { render, staticRenderFns } from "./ocrIdAuth.vue?vue&type=template&id=3ccea592&scoped=true&"
import script from "./ocrIdAuth.vue?vue&type=script&lang=js&"
export * from "./ocrIdAuth.vue?vue&type=script&lang=js&"
import style0 from "./ocrIdAuth.vue?vue&type=style&index=0&id=3ccea592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccea592",
  null
  
)

export default component.exports